import { createFileRoute } from '@tanstack/react-router'
import { ProjectTypesSection } from '../../../features/projects/project-types-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/project-types')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'project-types'),
  component: ProjectTypesSection,
})
